export default __webpack_public_path__ + "static/media/icon-ltc.20d7d4ca.svg";